const NAMESPACE = "markProjectRelatedDialog";

const KEYS = {
    markRelatedDialogText: "markRelatedDialogText",
    channelSelectLabel: "channelSelectLabel",
    markRelatedFromSingleConnectionText: "markRelatedFromSingleConnectionText",
    lookupProjectNumberInputLabel: "lookupProjectNumberInputLabel",
    lookupProjectBtnLabel: "lookupProjectBtnLabel",
    projectNotFoundText: "projectNotFoundText",
    foundProjectText: "foundProjectText",
    emptySlotValuePlaceholder: "emptySlotValuePlaceholder",
    additionalLookupInfoHeader: "additionalLookupInfoHeader",
    needsLookupValidationMessage: "needsLookupValidationMessage"
};

const MESSAGES = {
    [KEYS.markRelatedDialogText]: {
        value: "Mark this project as related to an existing project",
        comment: "Text that tells the user this dialog will let them mark a project as related to an existing project"
    },
    [KEYS.channelSelectLabel]: {
        value: "Using channel:",
        comment:
            "Label for the selector where user can optionally choose the connection to use when marking a project as related"
    },
    [KEYS.markRelatedFromSingleConnectionText]: {
        value: "Mark this project as related to an existing project using channel: {channelName}.",
        comment:
            "Text that informs the user they will be marking a project as related using the single available channel with the specified name"
    },
    [KEYS.lookupProjectNumberInputLabel]: {
        value: "Project number of target project:",
        comment:
            "Label for the input where the user enters the project number of the project to which they want to mark this project as related"
    },
    [KEYS.lookupProjectBtnLabel]: {
        value: "Check",
        comment:
            "Label for the button that allows the user to look up the related project based on the number they entered"
    },
    [KEYS.projectNotFoundText]: {
        value: "Project not found in the target program.",
        comment: "Text that tells the user that no project was found matching the number they entered"
    },
    [KEYS.foundProjectText]: {
        value: "Found project {projectNumber}",
        comment: "Text telling the user that a project was found matching the number they entered"
    },
    [KEYS.emptySlotValuePlaceholder]: {
        value: "None",
        comment: "Placeholder that displays if there is no value for a specified lookup field in the looked-up project"
    },
    [KEYS.additionalLookupInfoHeader]: {
        value: "Additional information:",
        comment: "Header for the the optional list of additional results when looking up a project by number"
    },
    [KEYS.needsLookupValidationMessage]: {
        value: "Please click the button to look up this project number in order to continue.",
        comment:
            "Validation message telling the user they need to click the button to validate the project number they entered before proceeding."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
